import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AdminService } from 'src/app/services/admin.service';

@Component({
  selector: 'ness-enable-disable',
  templateUrl: './enable-disable.component.html'
})
export class EnableDisableComponent implements OnDestroy, OnInit {
  filteredUsers: ServerModels.UserInfoViewModel[] = [];
  isSubmitted: boolean;
  selectedUser: ServerModels.UserInfoViewModel;
  selectedValue: string;

  private _unsubscribe$: Subject<void> = new Subject<void>();
  constructor(private adminService: AdminService,
    private messageSvc: MessageService) { }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
    this.messageSvc.clear('userStatusMsg');
  }

  ngOnInit() {
    this.selectedUser = this.newUserInfoViewModel();
  }

  public onSubmit(userForm: NgForm): void {
    this.isSubmitted = false;
    let value: ServerModels.UserInfoViewModel = userForm.form.get('Email').value;
    let data = {
      'username': value.Email,
      'disable': this.selectedValue
    };
    this.adminService.disableEnableUser(data).pipe(takeUntil(this._unsubscribe$)).subscribe({
      complete: () => {
        this.messageSvc.add({ key:'userStatusMsg', severity: 'success', summary: 'Success', detail: 'User status is updated.' });
        this.isSubmitted = true;
        this.selectedUser = this.newUserInfoViewModel();
        this.selectedValue = '';
        this.refreshUserList();
      },
      error: (err: any) => {
        this.isSubmitted = false;
        this.selectedUser = null;
      }
    });
  }

  public searchUsers(event: { originalEvent: Event, query: string}): void {
    let query = event.query;
    this.isSubmitted = false;
    this.adminService.getAllUsers(query).pipe(takeUntil(this._unsubscribe$)).subscribe((users: ServerModels.UserInfoViewModel[]) => {
      this.filteredUsers = [...users];
    });
  }

  public refreshUserList(): void {
    const lazyLoadEvent: LazyLoadEvent = { "first": 0, "rows": 20, "sortOrder": 1, "filters": {}, "globalFilter": null };

    this.adminService.loadUsersList(lazyLoadEvent);
  }

  private newUserInfoViewModel(): ServerModels.UserInfoViewModel {
    return {
      Email: '',
      Disabled: true,
      Deleted: false,
      PhoneNumber: null,
      PhoneNumberConfirmed: false,
      TwoFactorEnabled: true,
      LastLoginTimestamp: null
    };
  }
}
